import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./styles.css";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const MoveForm = lazy(() => import("./components/MoveForm"));
const Services = lazy(() => import("./components/Services"));
const Reviews = lazy(() => import("./components/Reviews"));
const WhyUs = lazy(() => import("./components/WhyUs"));

function App() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <Router>
      <div className="app-container">
        <Header />
        <main>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/move-form" element={<MoveForm />} />
              <Route path="/services" element={<Services />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/why-us" element={<WhyUs />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <button className="back-to-top" onClick={scrollToTop}>
          ▲
        </button>
      </div>
    </Router>
  );
}

export default App;
